import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";
import { COUPLE } from "./data";

const TARGET = new Date(COUPLE.weddingIso).getTime();

const getParts = () => {
    const diff = Math.max(0, TARGET - Date.now());
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
};

const UNIT_LABELS = [
    ["days", "Days"],
    ["hours", "Hours"],
    ["minutes", "Minutes"],
    ["seconds", "Seconds"],
];

const Countdown = () => {
    const [parts, setParts] = useState(getParts);

    useEffect(() => {
        const id = setInterval(() => setParts(getParts()), 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <section
            id="countdown"
            data-testid="countdown-section"
            className="relative border-y border-gold/10 bg-royal-surface/40 py-20 sm:py-28"
        >
            <div className="mx-auto max-w-5xl px-6 text-center">
                <Reveal>
                    <p className="font-cinzel text-[11px] font-semibold uppercase tracking-[0.5em] text-gold">
                        The Auspicious Hour Approaches
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <p className="mt-4 font-royal text-xl italic text-sand sm:text-2xl">
                        Until Sehra Bandhi — 22 November 2026, 6:30 PM
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-6">
                    {UNIT_LABELS.map(([key, label], i) => (
                        <Reveal key={key} delay={0.15 + i * 0.1}>
                            <div
                                data-testid={`countdown-${key}`}
                                className="group relative overflow-hidden rounded-lg border border-gold/25 bg-royal-card/80 px-4 py-8 transition-colors duration-500 hover:border-gold/60"
                            >
                                <span className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />
                                <span className="gold-shimmer animate-shimmer-sweep block font-cinzel text-4xl font-bold tabular-nums sm:text-5xl lg:text-6xl">
                                    {String(parts[key]).padStart(2, "0")}
                                </span>
                                <span className="mt-3 block font-cinzel text-[10px] font-semibold uppercase tracking-[0.4em] text-mutedgold">
                                    {label}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Countdown;
